import React from 'react';
import classNames from 'classnames';

import Icon from '../Icon/Icon';

import styles from './MapControlLocationButton.module.scss';

export enum LocationStatus {
  INACTIVE = 'inactive',
  SEARCHING = 'searching',
  FOUND = 'found',
  DISABLED = 'disabled',
}

export interface Props {
  className?: string;
  status: LocationStatus;
  size?: 'regular' | 'large' | 'extra-large';
  onClick: () => void;
  dataQA: string;
}

const MapControlLocationButton: React.FC<Props> = ({
  className,
  status,
  size = 'regular',
  onClick,
  dataQA,
}) => {
  let iconType = 'near_me_outline';

  switch (status) {
    case LocationStatus.FOUND:
      iconType = 'near_me';
      break;
    case LocationStatus.DISABLED:
      iconType = 'near_me_disabled_outline';
      break;
    default:
      iconType = 'near_me_outline';
  }

  return (
    <button
      data-qa={dataQA}
      disabled={status === LocationStatus.DISABLED}
      className={classNames(styles.container, styles[size], className, {
        [styles.found]: status === LocationStatus.FOUND,
        [styles.searching]: status === LocationStatus.SEARCHING,
      })}
      onClick={onClick}
    >
      <Icon
        dataQA="location-button"
        name={iconType}
        size={24}
        className={styles.icon}
      />
    </button>
  );
};

export default MapControlLocationButton;
